import m from "../../geodata/es2015/denmarkHigh";
window.am4geodata_denmarkHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/denmarkHigh.js
// module id = null
// module chunks = 